import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {WalletService_GetWalletLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.grpc.lazy';
import {useIsPersonalisationConsentGiven} from '@aboutyou/storage';
import {
  useBasketToken,
  useFullSession,
  useUserEmail,
  useWishlistMinimalState,
} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';

export const useGetWallet = (disabled?: boolean) => {
  const fullSession = useFullSession();
  const {targetGroup} = useSelectedTargetGroup();
  const {token: basketToken} = useBasketToken();
  const wishlistStateResponse = useWishlistMinimalState();
  const wishlistState = wishlistStateResponse.data?.wishlistState;

  const userEmail = useUserEmail();
  const isConsentBannerAccepted = useIsPersonalisationConsentGiven();

  return useGrpcRequest(
    WalletService_GetWalletLazy,
    {
      session: fullSession!,
      targetGroup,
      reductionsState: useReductionsStateRequestParameter(),
      basketToken,
      wishlistState: wishlistState!,
      enableConsentCompliantNotifications: isConsentBannerAccepted,
      appSource: null, // unused for now
      email: userEmail ?? null,
    },
    {
      disabled: disabled || !fullSession || !wishlistState,
    },
  );
};
